// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "button[data-v-78b9c298]{color:#000;border:2px solid var(--lms-tenant)}", ""]);
// Exports
module.exports = exports;
